// https://vuex.vuejs.org/en/modules.html
import Authentication from './authentication'
import Receipt from './receipt'

export default {
  'AUTH': Authentication,
  'RECEIPT': Receipt
}
